<template>
  <div>
    <div class="bg-color-red userform_top"></div>
    <div class="userform">
      <h3 class="userform_title">申请信息</h3>
      <div class="userform_item userform_item_red">
        <!-- <input type="text" placeholder="姓名" v-model.trim="formList.name"/>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 1">{{formlabel.text}}不能为空</p> -->
        姓名：{{apply_detail.name}}
      </div>
      <div class="userform_item userform_item_red">
        <!-- <input type="number" placeholder="手机号码" v-model.trim="formList.phone"/>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 2">{{formlabel.text}}不能为空</p> -->
        手机号码：{{apply_detail.phone}}
      </div>
      <!-- <div class="userform_item userform_item_red">
        <input type="number" placeholder="验证码" max="999999" v-model.trim="formList.verifi" class="yzm_number"/>
        <div class="yzm" :class="{'actived' : yzm.yzmstatus }" @click="yzmClick()">{{yzm.text}}</div>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 3">{{formlabel.text}}不能为空</p>
      </div> -->
      <div class="userform_item">
        <div class="item acea-row row-between-wrapper">
        <div class="name">加盟标准：{{apply_detail.condition}}</div>
        <!-- <div
          class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right" @click.stop="startShow = true">
              {{ joinStandard.text || "请选择加盟标准" }}
            </div>
            <van-popup v-model="startShow" position="bottom">
              <van-picker
                title="选择加盟标准"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="startShow = false"
              />
            </van-popup>
          </div>
        </div> -->
      </div>
      </div>
      <div class="userform_item">
        <div class="item acea-row row-between-wrapper">
        <div class="name">所在城市：{{apply_detail.agent_province}} {{apply_detail.agent_city}}</div>
        <!-- <div
          class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "请选择收货地址" }}
            </div>
            <CitySelect
              ref="cityselect"
              v-model="show2"
              :callback="result2"
              :items="district"
              :ready="ready"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div> -->
      </div>
      </div>
      <div class="uploader_form">
        <div class="tips">营业执照</div>
          <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(item,index) in apply_detail.business_license"
            :key="index"
          >
            <img :src="item"  @click="getImg(1)">
            <!-- <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="businessLicense.splice(index, 1)"
            ></div> -->
          </div>
          <!-- <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="businessLicense.length < 1"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传照片</div>
            </div>
          </VueCoreImageUpload> -->
        </div>
        
      </div>
      <div class="uploader_form">
        <div class="tips">法人身份证照片</div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(item,index) in apply_detail.id_card"
            :key="index"
          >
            <img :src="item" @click="getImg(2)">
          </div>
          <!-- <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="idCarduploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="IdCard.length < 2"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传照片</div>
            </div>
          </VueCoreImageUpload> -->
        </div>
      </div>
      <div 
        class="uploader_form"
        v-if="apply_detail.other_images != 0"
        >
        <div class="tips">其他照片</div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(item,index) in apply_detail.other_images"
            :key="index"
          >
            <img :src="item" @click="getImg()">
          </div>
        </div>
      </div>
      <div class="userform_item userform_item_textarea">
        备注信息:{{apply_detail.content}}
      </div>
      <div class="btn-list">
        <button class="userform_submit refuse" @click="refuseApply()">
        拒绝申请
      </button>
      <button class="userform_submit bg-color-red" @click="passApply()">
        通过申请
      </button>
      </div>
      
    </div>
    
  </div>
</template>
<script>


import { VUE_APP_API_URL } from "@utils";
import{ getApplyDetail ,  passApply , refuseApply} from "@api/user.js"
import VueCoreImageUpload from "vue-core-image-upload";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { conditionCreate } from "@api/order"
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
const _isWeixin = isWeixin();
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import ImagePreview  from 'vant/lib/image-preview';
import 'vant/lib/image-preview/style';
export default {
  name:"CityAgentForm",
  components:{
    VueCoreImageUpload,
    CitySelect,
    [Picker.name]:Picker,
    [Popup.name]:Popup,
    [ImagePreview .name]:ImagePreview,
  },
  data: function() {
    return {
      
      
      // 加盟方式
      startShow:false,
      columns: [],
      joinStandard:"",
      // 图片上传
      
      
      businessLicense:[],
      IdCard:[],
      otherImages:[],
      //
      
      
      
      
      
      refund_reason_wap_img:[],
      // 城市选择弹窗
      show2: false,
      model2: "",
      district: [],
      address: {},
      ready: false,

      apply_id:"",
      apply_detail:{}
    }
  },
  mounted: function() {
    this.apply_id = this.$route.query.id;
    this.getApplyDetail()
  },
  methods: {
    getApplyDetail(){
      getApplyDetail(this.apply_id).then(res=>{
        this.apply_detail = res.data.result;
        if(this.apply_detail.status != 0){
          this.$dialog.message("该申请已被处理！")
          this.$router.go(-1);
        }
      }).catch(res=>{
        this.$dialog.error(res.msg)
      })
    },
    showPopup() {
      this.startShow = true;
    },
    imageuploaded(res) {
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.businessLicense.push(res.data.url);
    },
    idCarduploaded(res){
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.IdCard.push(res.data.url);
    },
    otherImagesuploaded(res){
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.otherImages.push(res.data.url);
    },
    openAgentLevel () {
      this.agentlevelshow = !this.agentlevelshow;
    },
    closeAgentLevel (index) {
      this.checklevel = false;
      this.formList.agentlevelname = this.agentarray[index].name;
      this.formList.agentlevelamount = this.agentarray[index].amount;
      this.agentlevelshow = false;
    },
    getImg(value){
      if(value == 1){
        ImagePreview(this.apply_detail.business_license)
      }else if(value == 2){
        ImagePreview(this.apply_detail.id_card)
      }else{
        ImagePreview(this.apply_detail.other_images)
      }
    },
    // 通过申请
    passApply(){
      passApply(this.apply_id).then(res=>{
        let that = this;
        that.$dialog.success(res.msg);
        setTimeout(function(){
          that.$router.back();
        },1000)
      }).catch(err =>{
        this.$dialog.error(err.msg);
      })
    },
    // 拒绝申请
    refuseApply(){
      refuseApply(this.apply_id).then(res =>{
        let that = this;
        that.$dialog.success(res.msg);
        setTimeout(function(){
          that.$router.back();
        },1000)
      }).catch(err=>{
        this.$dialog.error(`${err.msg}，请勿重复操作`);
      })
    }
  },
  
};
</script>
<style scoped>
.uploader_form{
  margin-bottom: .2rem;
}
.uploader_form .upload .pictrue {
  margin-right: .22rem;
  width: 1.56rem;
  height: 1.56rem;
  position: relative;
  font-size: 0.24rem;
  color: #bbb;
  border: 1px solid #bbb;
}
.uploader_form .upload .pictrue img{
  width: 100%;
  height: 100%;
}
.uploader_form .upload .pictrue .icon-guanbi1 {
  position: absolute;
  font-size: 0.45rem;
  top: -0.1rem;
  right: -0.1rem;
  width: 0.45rem;
  height: 0.45rem;
  line-height: 0.45rem;
}
.userform_top {
  width: 100%;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background: linear-gradient(0deg, #434343, #000000);
  background: -webkit-linear-gradient(0deg, #434343, #000000);
  background: -moz-linear-gradient(0deg, #434343, #000000);
  background: -ms-linear-gradient(0deg, #434343, #000000);
}
.userform {
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 0.8em;
  padding: 1.6em;
  width: 85%;
  margin: 50px auto 50px;
  background: #ffffff;
  box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, 0.08);
  color: #000;
  position: relative;
  z-index: 1000;
}
.userform .userform_title {
  text-align: center;
  font-size: 20px;
  padding-bottom: 1.2em;
}
.userform .userform_item {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1.6em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
/* .userform .userform_item_red:before{
  content: "*";
  display: block;
  padding: 0 0.4em;
  color: rgb(223, 53, 53);
  position: absolute;
} */
.userform .userform_item .yzm{
  width: 7.6em;
  padding: 0 0.6em;
  background: #80cdd4;
  color: #ffffff;
  margin-left: 0.6em;
  line-height: 2.4em;
  text-align: center;
}
.userform .userform_item_agent {
  border-bottom: 1px solid #80cdd4;
  color: #80cdd4;
}
.userform  .userform_item_agent .agent_level_info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 2.4em;
  padding-left: 1.2em;
}
.userform .userform_item_agent .agent_level_child {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  top: 2.4em;
  z-index: 1000;
  color: #000;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  line-height: 2em;
  padding: 1em;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #80cdd4;
}
.userform .userform_item_agent .agent_level_name span{
  display: inline-block;
  color: #80cdd4;
  font-weight: 600;
  margin-right: 0.3em;
}
.userform .userform_item .yzm.actived{
  background: #f2f2f2;
  color: #999999;
}
.userform .userform_item .yzm_number{
  width: 8em;
  text-align: center;
  letter-spacing: 1px;
}
.userform .userform_item .agentcode{
  width: 10.6em;
  text-align: center;
  color: #000;
  margin-right: 0.4em;
}
.userform .userform_item input,
.userform .userform_item textarea {
  width: 100%;
  display: block;
  background: #f5f5f5;
  border-radius: 4px;
  color: #000;
  line-height: 1.6em;
  padding: 0.6em 0.6em;
}
.userform .userform_item input {
  line-height: 2.4em;
  padding: 0 1em;
}
.userform .userform_item_textarea.userform_item {
  align-items: flex-start;
}
.userform .userform_item_bottom {
  display: flex;
}
.userform .userform_item .userform_agreement {
  display: flex;
}
.userform .userform_item .userform_agreement span {
  color: #80cdd4;
}
.userform_item_label{
  font-size: 12px;
  color: rgb(255, 70, 70);
  position: absolute;
  left: 0;
  bottom: -2em;
  z-index: 1000;
  text-indent: 1em;
  line-height: 2em;
  text-align: left;
}
.userform_submit {
  margin: 0 auto;
  display: block;
  width: 45%;
  line-height: 2.4em;
  border-radius: 1.2em;
  background: linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -webkit-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -moz-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -ms-linear-gradient(90deg, #80cdd4, #80cdd4);
  text-align: center;
  font-weight: 600;
  color: #452f0d;
}
.userform_description {
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  padding-top: 2em;
  line-height: 1.6em;
  color: #80cdd4;
}
.userform_description p {
  font-size: 1.2em;
  display: inline-block;
  font-weight: 600;
}
.uploader_form .tips{
  font-size: .3rem;
  color: #000;
  margin-bottom: .2rem;
}
.uploader_form .tips span{
  color: rgb(223, 53, 53);
}
.btn-list{
  display: flex;
}
button.userform_submit.refuse{
  background: #ccc;
}
</style>
